import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModalStackChildren extends Vue {
  @Prop() indexNumber?: number;
  completed: boolean = false
  nextIndexModal: number = 0

  created() {
    this.$parent?.$on('open-modal', (indexedModal: number) => {
      if (this.indexNumber && this.indexNumber <= indexedModal) this.nextIndexModal = indexedModal + 1;
    });
  }

  get isButtonActive() {
    if (this.indexNumber && this.indexNumber >= this.nextIndexModal)
      return true;
    return false;
  }

  isTheNextModalAvailable(): boolean {
    return (this.indexNumber && this.indexNumber <= this.nextIndexModal) || !this.indexNumber;
  }
}
